import { kAgentAssistantRouterApiBasePath } from '@/constants/constants-api-paths'
import { kErrorCodeAuthError } from '@/constants/constants-error-codes'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getAuth } from 'firebase/auth'
import { nanoid } from 'nanoid'
import * as Sentry from '@sentry/browser'
import { ApiError } from '@/util/errors/api-error'

export default async function patchGenerateAgentConversationTitle(conversationId: string): Promise<void> {
  // Create transaction id
  const sentry_transaction_id = nanoid()

  try {
    // Retrieve the current user's authentication token
    const token = await getAuth().currentUser?.getIdToken(true)
    if (!token) throw new Error(kErrorCodeAuthError)

    const requestOptions: RequestInit = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Transaction-Id': sentry_transaction_id,
        Authorization: `Bearer ${token}`,
      },
      method: 'PATCH',
    }

    const apiUrl = `${kPaxtonAppApiRESTBaseUrl()}${kAgentAssistantRouterApiBasePath}/conversations/${conversationId}/title/generate`

    const response = await fetch(apiUrl, requestOptions)
    const data = await response.json()

    // Handle non-OK responses
    if (!response.ok) {
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentry_transaction_id })

        Sentry.captureException(new Error(`Fetch error - status: ${response.status}, detail: ${data.detail}`), {
          extra: {
            requestUrl: apiUrl,
            requestOptions: requestOptions,
            responseData: JSON.stringify(data),
            onLine: navigator.onLine,
            cookieEnabled: navigator.cookieEnabled,
          },
        })
      })
      throw new ApiError(response.status, `Fetch error - status: ${response.status}, detail: ${JSON.stringify(data.detail)}`)
    }
  } catch (error) {
    // Skip api errors already captured above
    if (!(error instanceof ApiError)) {
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentry_transaction_id })

        Sentry.captureException(error, {
          extra: { onLine: navigator.onLine, cookieEnabled: navigator.cookieEnabled },
        })
      })
      throw error
    }
  }
}
